export default {
    chat: {
        enable: 'chat.enable',
        disable: 'chat.disable',
        contexts: {
            event: 'event'
        }
    },
    event: {
        published: 'event.published',
        pay_as_you_go: 'event.pay_as_you_go',
        changed: 'event.changed',
        publish_data_changed: 'event.publish_data_changed',
    },
    events: {
         modal_create_event_closed: 'events.modal_create_event_closed',
         created: 'events.created',
    },
    certification: {
        open: 'certification.open',
        submitted: 'certification.submitted',
    }
}